import styled, { css } from 'styled-components'

const BackgroundModal = styled.div<{ opacity?: number; background?: string; centered?: boolean }>`
  position: fixed;
  z-index: 2147483003;
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;
  background-color: ${({ background, theme: { colors } }) => (background ? background : colors.asideTogle)};
  transition: all 0.3s;
  opacity: ${({ opacity }) => (typeof opacity !== 'undefined' ? opacity : 1)};
  ${({ centered }) =>
    centered &&
    css`
      padding-inline-start: 20px;
      padding-right: 20px;
      display: flex;
      justify-content: center;
      align-items: center;
    `}
`
export default BackgroundModal
